__webpack_require__.p = "https://delightful-field-0383ab300.2.azurestaticapps.net/";